<template>
  <div id="create-post-modal">
    <transition name="fade">
      <div class="post-modal">
        <div class="post-modal-content">
          <div class="post-modal-header">
            <a @click="closeCreatePostModal()" class="close"><i class="far fa-times"></i></a>
            <p class="lead" v-if="editMode == false">Create Post</p>
            <p class="lead" v-if="editMode == true">Edit Post</p>
          </div><!-- /.post-modal-header -->
          <form @submit.prevent>
            <div class="post-modal-body">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group">
                    <label for="postTitleInput">Title</label>
                    <input v-model="post.title" class="form-control" id="postTitleInput"/>
                  </div><!-- /.form-group -->
                  <div class="form-group">
                    <label for="postBodyInput">Body</label>
                    <quill-editor ref="myTextEditor" v-model="post.body" :options="editorOption"></quill-editor>
                  </div><!-- /.form-group -->
                  <!-- MEDIA INPUT -->
                  <div class="form-group">
                    <label for="mediaInput">Media</label>
                    <MediaInput v-on:mediaDelivery="mediaDelivery($event)" v-on:processingMedia="processingMedia($event)" :mediaObject="post.media"></MediaInput>
                  </div><!-- /.form-group -->
                  <div class="form-group">
                    <label for="pac-input">Location</label>
                    <vue-google-autocomplete
                      ref="address"
                      id="autoAddress"
                      classname="form-control"
                      placeholder="Search for an address to add pin to map!"
                      v-on:placechanged="getAddressData"
                    >
                  </vue-google-autocomplete><br>
                    <div id="map" style="background-color:black;width:100%;height:300px;"></div>
                  </div><!-- /.form-group -->
                </div><!-- /.col-md-8 .align-self-center -->
                <div class="col-md-4">
                  <div class="input-group">
                    <label for="datePicker">Start/End Dates</label>
                    <date-picker type="year" format="YYYY" v-model="post.dates" range :shortcuts="shortcuts" :lang="lang" :placeholder="'Start/End Years'" v-if="yearsOnly == true"></date-picker>
                    <date-picker v-model="post.dates" range :shortcuts="shortcuts" :lang="lang" :placeholder="'Specify Start/End Days'" v-if="yearsOnly == false"></date-picker>
                    <p class="lead" v-if="yearsOnly == true"><a class="toggleDatePickerMode" @click="yearsOnly = false"><i class="fas fa-toggle-on"></i></a> Years Only</p>
                    <p class="lead" v-if="yearsOnly == false"><a class="toggleDatePickerMode" @click="yearsOnly = true"><i class="fas fa-toggle-off"></i></a> Years Only</p>
                  </div><!-- /.input-group -->
                  <p class="lead">Figures</p>
                  <div class="form-group">
                    <label for="postCostInput">Cost</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="cost-addon">$</span>
                      </div>
                      <input v-model.trim="post.figures.cost.value" id="postCostInput" type="number" class="form-control" aria-label="Cost" aria-describedby="cost-addon" />
                    </div><!-- /.input-group .mb-3 -->
                    <label for="postGrantFundsInput">Grant Funds</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="grant-funds-addon">$</span>
                      </div>
                      <input v-model.trim="post.figures.grantFunds.value" id="postGrantFundsInput" type="number" class="form-control" aria-label="Grant Funds" aria-describedby="grant-funds-addon" />
                    </div><!-- /.input-group .mb-3 -->
                    <label for="postPrivateFundsInput">Private Funds</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="private-funds-addon">$</span>
                      </div>
                      <input v-model.trim="post.figures.privateFunds.value" id="postPrivateFundsInput" type="number" class="form-control" aria-label="Private Funds" aria-describedby="private-funds-addon" />
                    </div><!-- /.input-group .mb-3 -->
                    <label for="postLocalFundsInput">Local Funds</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="local-funds-addon">$</span>
                      </div>
                      <input v-model.trim="post.figures.localFunds.value" id="postLocalFundsInput" type="number" class="form-control" aria-label="Local Funds" aria-describedby="local-funds-addon" />
                    </div><!-- /.input-group .mb-3 -->
                  </div><!-- /.form-group -->

                  <!-- ADVANCED OPTIONS -->
                  <p class="lead">Advanced</p>

                  <div class="form-group">
                    <label for="autoplayVideo">Autoplay Video (Youtube Link)</label>
                    <input v-model="post.autoplayVideo" class="form-control" id="autoplayVideo"/>
                  </div>

                  <!-- LINKS -->
                  <div class="form-group">
                    <label>External Links</label>
                    <div class="external-link mb-1" v-for="(link, index) in post.links">
                      <div class="row">
                        <div class="col">
                          <button @click="removeLink(index)" class="btn btn-default btn-danger btn-sm mt-1"><i class="far fa-minus-circle"></i></button>
                        </div><!-- /.col-sm-2 -->
                        <div class="col-sm-5 pl-0">
                          <input type="text" class="form-control" v-model="link.title" placeholder="Link Title">
                        </div><!-- /.col-sm-5 -->
                        <div class="col-sm-5 pl-0">
                          <input type="text" class="form-control" v-model="link.url" placeholder="URL">
                        </div><!-- /.col-sm-6 -->
                      </div><!-- /.row -->
                    </div><!-- /.external-link -->
                    <button class="btn btn-default btn-primary btn-sm" style="width:100%" @click="addLink()"><i class="far fa-plus-circle"></i> Add Link</button>
                  </div><!-- /.form-group -->

                </div><!-- /.col-md-4 -->
              </div><!-- /.row -->
            </div><!-- /.post-modal-body -->
            <div class="post-modal-footer">
              <div class="float-right">
                <button @click="updatePost()" v-if="processingMedias == false" class="btn btn-primary">Save</button>
                <button v-if="processingMedias == true" class="btn btn-warning" disabled><em>Processing...</em></button>
                <button v-if="editMode == true" @click="deletePost()" class="btn btn-danger">Delete</button>
                <button @click="closeCreatePostModal()" class="btn btn-default">Cancel</button>
              </div><!-- /.btn-group -->
            </div><!-- /.post-modal-footer -->
          </form>
        </div><!-- /.post-modal-content -->
      </div><!-- /.post-modal -->
    </transition>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import firebase from 'firebase'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  const fb = require('../firebaseConfig.js')
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { quillEditor } from 'vue-quill-editor'
  import MediaInput from './MediaInput.vue'
  import DatePicker from 'vue2-datepicker'

  let createPostMap = {}

  export default {
    components: { VueGoogleAutocomplete, quillEditor, MediaInput, DatePicker },
    data() {
      return {
        post: {
          title: '',
          body: '',
          media: [],
          autoplayVideo: '',
          coordinates: {
            latitude: '',
            longitude:''
          },
          address: {
            street_number: '',
            route: '',
            locality: '',
            administrative_area_level_1: '',
            administrative_area_level_2: '',
            postal_code: ''
          },
          figures: {
            cost: {
              title: "Cost",
              type: "Money",
              value: NaN
            },
            grantFunds: {
              title: "Grant Funds",
              type: "Money",
              value: NaN
            },
            privateFunds: {
              title: "Private Funds",
              type: "Money",
              value: NaN
            },
            localFunds: {
              title: "Local Funds",
              type: "Money",
              value: NaN
            }
          },
          dates: {},
          links: [
            {
              title: '',
              url: ''
            }
          ]
        },
        lang: 'en',
        shortcuts: [],
        selectedFile: null,
        yearsOnly: true,
        editMode: false,
        processingMedias: false,
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'header': [1, 2, 3, false] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'video']
            ]
          }
        }
      }
    },
    computed: {
      ...mapState(['userProfile', 'currentUser'])
    },
    props: ['fullPost'],
    created: function () {
      // if there is a fullPost prop, then use it to pre-populate the form, declare editMode = true
      if (this.fullPost) {
        // Set edit mode
        this.editMode = true
        // Set up the post props using the injected fullPost
        this.post = this.fullPost
        // Setup the post.dates prop so that the datepicker can read it
        //Start by getting the existing dates
        if (this.post.dates.start != null) {
          let startDate = this.post.dates.start.toDate()
          let endDate = this.post.dates.end.toDate()
          // Clear the past.dates prop
          this.post.dates = []
          // Inject so that the date picker can read it and model to it
          this.post.dates[0] = startDate
          this.post.dates[1] = endDate
        }
        // Check to see if any links exist. If not, create a blank link
        if (!this.post.links) {
          this.post.links = [{title: '', url: ''}]
        }
      }

      let map = null;
      let self = this

      setTimeout(function () {
        map = new google.maps.Map(document.getElementById('map'), {
          center: {lat:0,lng:0},
          zoom: 2
        });
      }, 10);

      function mapInit() {
        map.setCenter({lat: self.post.coordinates.latitude, lng: self.post.coordinates.longitude});
        map.setZoom(12);
        let marker = new google.maps.Marker({
          map: map,
          draggable: true,
          position: {lat: self.post.coordinates.latitude, lng: self.post.coordinates.longitude}
        })
        google.maps.event.addListener(marker, 'dragend', function(marker){
          let lat = marker.latLng.lat();
          let lng = marker.latLng.lng();
          self.post.coordinates = {}
          self.post.coordinates.latitude = lat
          self.post.coordinates.longitude = lng
        });
      }
      function usePosition(position) {
        self.post.coordinates.latitude = position.coords.latitude
        self.post.coordinates.longitude = position.coords.longitude
        mapInit()
      }
      function getLocation() {
        if (navigator.geolocation && self.editMode == false) {
          navigator.geolocation.getCurrentPosition(usePosition)
        } else {
          mapInit()
        }
      };
      setTimeout(function () {
        getLocation();
      }, 20);
    },
    methods: {
      addLink() {
        this.post.links.push({
          title: '',
          url: ''
        })
      },
      removeLink(index) {
        this.post.links.splice(index, 1)
      },
      mediaDelivery(mediaPayload) {
        this.post.media = mediaPayload
      },
      getAddressData: function (addressData, placeResultData, id) {
        this.post.address = {
          street_number: addressData.street_number || '',
          route: addressData.route || '',
          locality: addressData.locality || '',
          administrative_area_level_1: addressData.administrative_area_level_1 || '',
          administrative_area_level_2: addressData.administrative_area_level_2 || '',
          postal_code: addressData.postal_code || ''
        };
        let center = {lat: addressData.latitude, lng: addressData.longitude};
        this.post.coordinates.latitude = addressData.latitude
        this.post.coordinates.longitude = addressData.longitude
        let map = new google.maps.Map(document.getElementById('map'), {});
        map.setCenter(center);
        map.setZoom(12);
        let marker = new google.maps.Marker({
          map: map,
          draggable: true,
          position: center
        });
        google.maps.event.addListener(marker, 'dragend', function(marker){
          let lat = marker.latLng.lat();
          let lng = marker.latLng.lng();
          this.post.coordinates.latitude = lat
          this.post.coordinates.longitude = lng
        });
      },
      closeCreatePostModal() {
        this.$emit('closeCreatePostModal')
      },
      updatePost() {
        let lat = this.post.coordinates.latitude
        let lon = this.post.coordinates.longitude
        let geopoint = new firebase.firestore.GeoPoint(lat, lon)
        let figuresObject = {
          cost: {
            type: 'Money',
            title: 'Cost',
            value: Number(this.post.figures.cost.value)
          },
          grantFunds: {
            type: 'Money',
            title: 'Grant Funds',
            value: Number(this.post.figures.grantFunds.value)
          },
          privateFunds: {
            type: 'Money',
            title: 'Private Funds',
            value: Number(this.post.figures.privateFunds.value)
          },
          localFunds: {
            type: 'Money',
            title: 'Local Funds',
            value: Number(this.post.figures.localFunds.value)
          }
        }
        let dateObject = {
          yearsOnly: this.yearsOnly,
          start: this.post.dates[0] || null,
          end: this.post.dates[1] || null
        }
        // If editMode false, add new post
        if (this.editMode == false) {
          fb.postsCollection.add({
            createdOn: new Date(),
            userId: this.currentUser.uid,
            userName: this.userProfile.name,
            title: this.post.title,
            body: this.post.body,
            media: this.post.media,
            coordinates: geopoint,
            address: this.post.address,
            figures: figuresObject,
            dates: dateObject,
            autoplayVideo: this.post.autoplayVideo,
            links: this.post.links
          }).then(ref => {
            this.post.title = ''
            this.post.body = ''
            this.post.media = {}
            this.post.coordinates = {}
            this.post.autoplayVideo = ''
            this.post.links = []
            this.$emit('closeCreatePostModal')
          }).catch(err => {
            console.log(err)
          })
        }
        // If editMode true, update existing post
        if (this.editMode == true) {
          fb.postsCollection.doc(this.fullPost.id).update({
            createdOn: new Date(),
            userId: this.currentUser.uid,
            userName: this.userProfile.name,
            title: this.post.title,
            body: this.post.body,
            media: this.post.media,
            coordinates: geopoint,
            address: this.post.address,
            figures: figuresObject,
            dates: dateObject,
            autoplayVideo: this.post.autoplayVideo,
            links: this.post.links
          }).then(ref => {
            this.post.title = ''
            this.post.body = ''
            this.post.media = {}
            this.post.coordinates = {}
            this.post.autoplayVideo = ''
            this.post.links = []
            this.$emit('closeCreatePostModal')
          }).catch(err => {
            console.log(err)
          })
        }
      },
      deletePost() {
        let self= this;
        let check = confirm("Are you sure you want to delete this post?");
        if (check == true) {
          fb.postsCollection.doc(self.fullPost.id).delete()
          this.$emit('closeCreatePostModal')
        } else {
          return false;
        }
      },
      processingMedia(e) {
        this.processingMedias = e
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CreatePostModal.vue